export function handleException(error) {
    throw error;

    if (Object.hasOwn(error, 'response')) {
        if (Object.hasOwn(error.response, 'data')) {
            if (Object.hasOwn(error.response.data, 'code')) {
                if (error.response.data.code === 'INVALID_TOKEN') {
                    alert('token invalid')
                }
            }
        }
    }
}